import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import type { DeviceClassProductOfferMapping } from '@/libs/api/insurance/insurance.types.ts'
import { useInsuranceService } from '@/libs/api/insurance/insurance.service.ts'
import { parseDateString } from '@/utils/date-util.ts'
import { useInsuranceApiClientImpl } from '@/client/insurance-client-impl.ts'

export const useInsuranceStore = defineStore('insurance', () => {
  const client = useInsuranceApiClientImpl()
  const service = useInsuranceService(client)
  const deviceClassOffers = ref<DeviceClassProductOfferMapping>()

  const allProductOffers = computed(() => {
    const values = Object.values(deviceClassOffers.value ?? []).flat()
    const uniqueMap = new Map(values.map((offer) => [offer.id, offer]))
    return Array.from(uniqueMap.values())
  })

  async function loadProductSpec(params: {
    product_id?: string
    device_class_id?: string
    purchase_date?: string
    purchase_price?: string
  }) {
    return await service.fetchProductSpec({
      product_id: params.product_id ?? '',
      device_class_id: params.device_class_id ?? '',
      purchase_date: parseDateString(params.purchase_date ?? '').toDate(),
      purchase_price: Number(params.purchase_price)
    })
  }

  function setOffers(mapping: DeviceClassProductOfferMapping) {
    deviceClassOffers.value = mapping
  }

  function getDeviceClassOffers(deviceClassId: string) {
    return deviceClassOffers.value?.[deviceClassId] ?? []
  }

  return {
    deviceClassOffers,
    allProductOffers,
    getDeviceClassOffers,
    loadProductSpec,
    setOffers
  }
})
